import { render, staticRenderFns } from "./UpsellModal.vue?vue&type=template&id=64509985&"
import script from "./UpsellModal.vue?vue&type=script&lang=ts&"
export * from "./UpsellModal.vue?vue&type=script&lang=ts&"
import style0 from "./UpsellModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports